import { render, staticRenderFns } from "./IconFolderOutline.vue?vue&type=template&id=f8f57a00"
import script from "./IconFolderOutline.vue?vue&type=script&lang=js"
export * from "./IconFolderOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports